/* @flow */

import { FsdAddressType } from "shared/src/types/customer/FsdAddress";
import Customer from "shared/src/types/customer/Customer";

function getCustomerDeliveryAddresses(customer: Customer | undefined | null): Array<FsdAddressType> {
    if (customer && customer.validForFsd) {
        return filterForVisibleAddresses(customer.deliveryAddresses);
    }
    return [];
}

function getCustomerAddresses(customer: Customer | undefined | null): Array<FsdAddressType> {
    if (customer && customer.validForFsd) {
        return filterForVisibleAddresses(customer.addresses);
    }
    return [];
}

function filterForVisibleAddresses(addresses: Array<FsdAddressType> | null | undefined) {
    return Array.from(
        new Set(
            (addresses || []).filter((address) => address.accessibleByCurrentUser && !address.nonProductionRedirectUrl)
        )
    );
}

const exported = {
    getCustomerDeliveryAddresses: getCustomerDeliveryAddresses,
    getCustomerAddresses: getCustomerAddresses
};

export default exported;
export { getCustomerDeliveryAddresses, getCustomerAddresses };
